<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="event.id === null">{{ 'ARTICLE.NEWARTICLE' | translate }}</span>
            <span *ngIf="event.id !== null">{{ 'ARTICLE.EDITARTICLE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="eventForm" id="eventForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="eventForm" >
            <input type="hidden" name="id" id="eventId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-newspaper"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="category" [autoDisplayFirst]="false" formControlName="category" [options]="categories" (onChange)="onChange($event)" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="category" class="req">{{ 'CATEGORY.CATEGORY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="eventForm.controls['category'].invalid && (eventForm.controls['category'].dirty || eventForm.controls['category'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="eventForm.controls['category'].errors !== null">
                  <div *ngIf="eventForm.controls['category'].errors.required">
                   {{ 'ARTICLE.ARTICLETYPEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="eventTitle" formControlName="title" type="text" pInputText [required]="false"> 
                      <label for="eventTitle" class="">{{ 'TITLE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div>
            <div class="p-fluid p-grid">
              <!-- <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="eventTitleEn" formControlName="TitleEn" type="text" pInputText [required]="false"> 
                      <label for="eventTitleEn" class="">{{ 'TitleEn' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div> -->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="eventTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="eventTitleFr" class="">{{ 'TITLEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
            </div>
            
            <div class="p-fluid p-grid">
              
              <div class="p-field p-col-12">
                <label for="imagePath">Image</label>
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="icon-image"></i>
                  </span>
              
                  <input
                    type="file"
                    formControlName="picture"
                    description="picture"
                    class="w-100"
                    (change)="uploadPhoto($event)"
                    accept="file/*"
                  />
                </div>
              </div>
              

            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <label for="video">Video</label>

                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>


                    <input type="file"  formControlName="video" description="video" pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadVideo($event)" accept="file/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->

            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                  <label for="description" class="req">{{ 'DESCRIPTION' | translate }}</label>
                  <ckeditor  inputId="description" formControlName="description"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
                </div>
                <div *ngIf="eventForm.controls['description'].invalid && (eventForm.controls['description'].dirty || eventForm.controls['description'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="eventForm.controls['description'].errors !== null">
                  <div *ngIf="eventForm.controls['description'].errors.required">
                   {{ 'DESCRIPTION' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-12">

                <div class="p-field p-col-12">
                      <label for="descriptionFr" class="req">{{ 'DESCRIPTIONFR' | translate }}</label>
                      <ckeditor  inputId="descriptionFr" formControlName="descriptionFr"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
                </div>
                <div *ngIf="eventForm.controls['descriptionFr'].invalid && (eventForm.controls['descriptionFr'].dirty || eventForm.controls['descriptionFr'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="eventForm.controls['descriptionFr'].errors !== null">
                  <div *ngIf="eventForm.controls['descriptionFr'].errors.required">
                   {{ 'DESCRIPTIONFR' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div>
            </div>
          
            <div class="p-fluid p-grid">
              <div class="p-field p-col-12">
                <div class="p-field p-col-12">
                  <label for="date" class="req">{{ 'date' | translate }}</label>
                  <input
                    type="date"
                    id="date"
                    formControlName="date"
                    class="form-control"
                    [required]="true"
                  />
                </div>
              </div>
              
           
              
            <!-- <div class="p-col-12">

              <div class="p-field p-col-12">
                <div class="p-field p-col-12">
                  <label for="DescriptionEn" class="req">{{ 'DescriptionEn' | translate }}</label>
                  <ckeditor  inputId="DescriptionEn" formControlName="DescriptionEn"  [editor]="Editor" [config]="editorService.config" type="content"  [required]="true" ></ckeditor>
            </div>
              </div>
              <div *ngIf="eventForm.controls['DescriptionEn'].invalid && (eventForm.controls['DescriptionEn'].dirty || eventForm.controls['DescriptionEn'].touched)" class="alert alert-danger">
                <ng-container *ngIf="eventForm.controls['DescriptionEn'].errors !== null">
                <div *ngIf="eventForm.controls['DescriptionEn'].errors.required">
                 {{ 'DescriptionEn' | translate }}.
                </div>
                </ng-container>
              </div>

            </div> -->
            
            </div>

            <div class="p-fluid p-grid">

              <div class="p-col-12">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!postForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'ACTIONS.SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

